import { render, staticRenderFns } from "./ReportQuestionReview.vue?vue&type=template&id=163ad6dc&scoped=true"
import script from "./ReportQuestionReview.vue?vue&type=script&lang=js"
export * from "./ReportQuestionReview.vue?vue&type=script&lang=js"
import style0 from "./ReportQuestionReview.vue?vue&type=style&index=0&id=163ad6dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "163ad6dc",
  null
  
)

export default component.exports